module.exports = __webpack_public_path__ + "static/favicon196-9c09b1689d2b85f188a9d3ef63b3c2f5.png";